var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 36,
    viewBox: "0 0 36 36",
    width: 36,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#d9b334"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 10
  }), /*#__PURE__*/React.createElement("rect", {
    height: 6,
    rx: 0.5,
    width: 1,
    x: 17.5
  }), /*#__PURE__*/React.createElement("rect", {
    height: 6,
    rx: 0.5,
    width: 1,
    x: 17.5,
    y: 30
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 1 -1 0 36 17.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 6,
    rx: 0.5,
    width: 1
  }), /*#__PURE__*/React.createElement("rect", {
    height: 6,
    rx: 0.5,
    width: 1,
    y: 30
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.70710678 -.70710678 .70710678 .70710678 4.919 5.626)"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 6,
    rx: 0.5,
    width: 1
  }), /*#__PURE__*/React.createElement("rect", {
    height: 6,
    rx: 0.5,
    width: 1,
    y: 30
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.70710678 .70710678 -.70710678 .70710678 30.374 4.919)"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 6,
    rx: 0.5,
    width: 1
  }), /*#__PURE__*/React.createElement("rect", {
    height: 6,
    rx: 0.5,
    width: 1,
    y: 30
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSun);
export default __webpack_public_path__ + "static/media/icon-sun.f058d615ad52258005bbf3a9472470e7.svg";
export { ForwardRef as ReactComponent };